import { gql, QueryResult, useLazyQuery, useQuery } from '@apollo/client';

import {
  AvailableSponsorsLegacyQuery,
  AvailableSponsorsLegacyQueryVariables,
} from '@typings/operations';

type AvailableSponsorsQueryResult = Pick<
  QueryResult<AvailableSponsorsLegacyQuery>,
  'data' | 'error' | 'loading'
>;

export const availableSponsorsQuery = gql`
  query AvailableSponsorsLegacy(
    $clubId: String!
    $name: String!
    $admissionDate: String
    $currentIndividualId: String
    $pageSize: Int = 100
  ) {
    availableSponsors(
      clubId: $clubId
      name: $name
      admissionDate: $admissionDate
      individualId: $currentIndividualId
      pageSize: $pageSize
    ) {
      totalCount
      results {
        nameWithPrefixSuffix
        id
        activeMemberships {
          type
          admissionDate
          clubId
        }
      }
    }
  }
`;
export const useAvailableSponsorsQuery = (
  clubId: string,
  name?: string,
  admissionDate?: string,
  currentIndividualId?: string
): AvailableSponsorsQueryResult => {
  return useQuery<
    AvailableSponsorsLegacyQuery,
    AvailableSponsorsLegacyQueryVariables
  >(availableSponsorsQuery, {
    variables: {
      clubId,
      name: name || '',
      admissionDate,
      currentIndividualId,
    },
    skip: !clubId || clubId?.trim().length === 0 || !admissionDate,
  });
};

export const useAvailableSponsorsQueryLazy = () =>
  useLazyQuery<
    AvailableSponsorsLegacyQuery,
    AvailableSponsorsLegacyQueryVariables
  >(availableSponsorsQuery);
